export default "__VITE_ASSET__DztpQVT5__"